{{each state.tags tag index}}<oy-tag $label="{{tag.name}}" $value="{{tag.value}}" class="{{styles.tag}}"></oy-tag>{{/each}}


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYCategoryTab/selectedTag.art